import React from 'react';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import { Typography } from '@mui/material';

const ExportedTemplates = ({ detail }) => {
  const templates = detail?.data?.templates || [];

  return (
    <div className='flex flex-nowrap gap-4 py-8 items-strech justify-center overflow-auto'>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Template Name</TableCell>
              <TableCell>Number of questions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {templates?.length > 0 ? (
              templates.map((template, index) => {
                const { questions = [], title = '' } = template;

                return (
                  <TableRow key={`table-columd-body-${template?._id}-${index}`}>
                    <TableCell width={20} className='overflow-hidden'>
                      <Typography variant='body2' component={'span'}>
                        {index + 1}
                      </Typography>
                    </TableCell>
                    <TableCell width={300} className='overflow-hidden'>
                      <Typography variant='body2' component={'span'}>
                        {title || ''}
                      </Typography>
                    </TableCell>
                    <TableCell width={200} className='overflow-hidden'>
                      <Typography variant='body2' component={'span'}>
                        {questions?.length || 0}
                      </Typography>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={3}>
                  <Typography
                    color='inherit'
                    component={'p'}
                    className='text-muted-foreground opacity-50 py-2 text-center'
                  >
                    You don't have any templates yet
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ExportedTemplates;
